import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private llmConnectionSubject = new BehaviorSubject<any>(null); // Holds the llm value
  llmConnection$ = this.llmConnectionSubject.asObservable(); 

  private testCaseDeleted = new Subject<string>(); // Emits deleted test case ID
  testCaseDeleted$ = this.testCaseDeleted.asObservable(); 

  private versionUpdateSource = new Subject<void>();
  versionUpdate$ = this.versionUpdateSource.asObservable();

  constructor() {}
 

  notifyVersionUpdate() {
    this.versionUpdateSource.next();
  }

  setLLMConnection(connection: any): void {
    this.llmConnectionSubject.next(connection);
  }

  getLLMConnection(): any {
    return this.llmConnectionSubject.getValue();
  }

  notifyDelete(testCaseId: string) {
    this.testCaseDeleted.next(testCaseId); 
  }
}
